'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { trackEvent, trackPageView } from '@/lib/analytics/contract';

interface GoogleAnalyticsProps {
  measurementId: string;
}

export function GoogleAnalytics({ measurementId }: GoogleAnalyticsProps) {
  const pathname = usePathname();

  useEffect(() => {
    if (process.env.NODE_ENV === 'development' || typeof window === 'undefined') return;

    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function gtag(...args: unknown[]) {
        window.dataLayer?.push(args);
      };

    if (!window.__alpha5GaInitialized) {
      window.__alpha5GaInitialized = true;
      window.gtag('js', new Date());
      window.gtag('config', measurementId, {
        send_page_view: false,
      });
    }

    trackPageView(pathname);
    if (!pathname.includes('/auth/signin')) {
      try {
        if (window.sessionStorage.getItem('alpha5_login_started') === '1') {
          window.sessionStorage.removeItem('alpha5_login_started');
          trackEvent('login_outcome', {
            method: 'discord',
            outcome: 'success',
            error_code: 'none',
          });
        }
      } catch {
        // Analytics must never affect navigation.
      }
    }
  }, [measurementId, pathname]);

  if (process.env.NODE_ENV === 'development') {
    return null;
  }

  return (
    <Script
      strategy="afterInteractive"
      src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
    />
  );
}
